import styled from 'styled-components';

import { colors } from 'global/colors';
import { Link as BaseLink } from 'components/FormComponents/FormComponents';

export const Link = styled(BaseLink)`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${colors.fsDarkBlue};

  :hover {
    color: ${colors.fsCyan};
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;
